import React, { useEffect } from 'react';
import { Footer, Navbar, Breadcrumb } from '../components';
import { Link } from 'react-router-dom';
import { dataLayerPush } from '../helpers/dataLayer';

const Checkout = () => {
  const state = localStorage.getItem('cart') ? JSON.parse(localStorage.getItem('cart')) : [];

  useEffect(() => {
    window.scrollTo(0, 0);
    dataLayerPush({
      event: 'pageView',
      pageName: 'checkout',
    });
  }, []);

  const EmptyCart = () => {
    return (
      <div className='container'>
        <div className='row'>
          <div className='col-md-12 py-5 bg-light text-center'>
            <h4 className='p-3 display-5'>No item in Cart</h4>
            <Link to='/' className='btn btn-outline-dark mx-4'>
              <i className='fa fa-arrow-left'></i> Continue Shopping
            </Link>
          </div>
        </div>
      </div>
    );
  };

  const ShowCheckout = () => {
    let subtotal = 0;
    let shipping = 30.0;
    let totalItems = 0;
    state.map((item) => {
      return (subtotal += item.price * item.qty);
    });

    state.map((item) => {
      return (totalItems += item.qty);
    });
    return (
      <>
        <div className='container py-5'>
          <div className='row my-4'>
            <div className='col-md-5 col-lg-4 order-md-last'>
              <div className=''>
                <div className='mb-4'>
                  <h4 className='text-start mt-5 fw-light'>Cart</h4>
                  <div className='card-body px-2 rounded-3 mt-3' style={{ background: '#F9F9F9' }}>
                    <ul className='list-group list-group-flush pt-2'>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0'
                        style={{ background: '#F9F9F9' }}>
                        Order Total ({totalItems})<span>${Math.round(subtotal)}</span>
                      </li>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center px-0'
                        style={{ background: '#F9F9F9' }}>
                        Shipping
                        <span>${shipping}</span>
                      </li>
                      <li
                        className='list-group-item d-flex justify-content-between align-items-center border-0 px-0 my-3'
                        style={{ background: '#F9F9F9' }}>
                        <h6>Total amount</h6>

                        <h6>${Math.round(subtotal + shipping)}</h6>
                      </li>
                    </ul>
                    <a href='/summary' className='btn btn-sm btn-dark btn-lg btn-block mb-3 w-100'>
                      Place an Order
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-7 col-lg-8'>
              <h4 className='text-start mt-5 fw-light'>Address</h4>
              <div className='mb-4 mt-4'>
                <div className=''>
                  <form className='needs-validation' noValidate>
                    <div className='row g-3'>
                      <div className='col-sm-4 my-1'>
                        <label htmlFor='firstName' className='form-label'>
                          First name
                        </label>
                        <input type='text' className='form-control' id='firstName' placeholder='Your name' required />
                        <div className='invalid-feedback'>Valid first name is required.</div>
                      </div>

                      <div className='col-sm-4 my-1'>
                        <label htmlFor='lastName' className='form-label'>
                          Last name
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          id='lastName'
                          placeholder='Your family name'
                          required
                        />
                        <div className='invalid-feedback'>Valid last name is required.</div>
                      </div>
                      <div className='col-sm-4 my-1'>
                        <label htmlFor='email' className='form-label'>
                          Email
                        </label>
                        <input
                          type='email'
                          className='form-control'
                          id='email'
                          placeholder='you@example.com'
                          required
                        />
                        <div className='invalid-feedback'>Please enter a valid email address for shipping updates.</div>
                      </div>

                      <div className='col-sm-4 my-1'>
                        <label htmlFor='address' className='form-label'>
                          Address
                        </label>
                        <input type='text' className='form-control' id='address' placeholder='1234 Main St' required />
                        <div className='invalid-feedback'>Please enter your shipping address.</div>
                      </div>

                      <div className='col-sm-4 my-1'>
                        <label htmlFor='country' className='form-label'>
                          Country
                        </label>
                        <br />
                        <select className='form-select' id='country' required>
                          <option value=''>Choose...</option>
                          <option value='United Kingdom'>United Kingdom</option>
                          <option value='Turkey'>Turkey</option>
                        </select>
                        <div className='invalid-feedback'>Please select a valid country.</div>
                      </div>

                      <div className='col-sm-4 my-1'>
                        <label htmlFor='state' className='form-label'>
                          State
                        </label>
                        <br />
                        <select className='form-select' id='state' required>
                          <option value=''>Choose...</option>
                          <option value='London'>London</option>
                          <option value='Istanbul'>Istanbul</option>
                        </select>
                        <div className='invalid-feedback'>Please provide a valid state.</div>
                      </div>
                    </div>

                    <hr className='my-4' />

                    <h4 className='mb-3 fw-light'>Payment</h4>

                    <div className='row gy-3'>
                      <div className='col-md-6'>
                        <label htmlFor='cc-name' className='form-label'>
                          Name on card
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          id='cc-name'
                          placeholder='Full name as displayed on card'
                          required
                        />
                        <div className='invalid-feedback'>Name on card is required</div>
                      </div>

                      <div className='col-md-6'>
                        <label htmlFor='cc-number' className='form-label'>
                          Credit card number
                        </label>
                        <input
                          type='text'
                          className='form-control'
                          id='cc-number'
                          placeholder='Credit Cart Number'
                          required
                        />
                        <div className='invalid-feedback'>Credit card number is required</div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <Navbar />
      <div className='container mt-5'>
        <Breadcrumb category='checkout' />
        {state.length ? <ShowCheckout /> : <EmptyCart />}
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
